import { useCallback, useEffect, useState } from 'react'
import { match, P } from 'ts-pattern'

export const useDeviceSize = (
  mobileBoundary = 768,
  tabletBoundary = 1024
): { isMobile: boolean; isTablet: boolean; isDesktop: boolean } => {
  const [deviceSize, setDeviceSize] = useState<'mobile' | 'tablet' | 'desktop'>(
    'desktop'
  )

  const updateDeviceSize = useCallback(() => {
    const newSize: 'mobile' | 'tablet' | 'desktop' = match(window.innerWidth)
      .with(
        P.when(n => n <= mobileBoundary),
        () => 'mobile' as const
      )
      .with(
        P.when(n => n > mobileBoundary && n <= tabletBoundary),
        () => 'tablet' as const
      )
      .with(
        P.when(n => n > tabletBoundary),
        () => 'desktop' as const
      )
      .otherwise(() => 'desktop')

    setDeviceSize(newSize)
  }, [mobileBoundary, tabletBoundary])

  useEffect(() => {
    updateDeviceSize()
    window.addEventListener('resize', updateDeviceSize)
    return () => {
      window.removeEventListener('resize', updateDeviceSize)
    }
  }, [mobileBoundary, tabletBoundary, updateDeviceSize])

  return {
    isMobile: deviceSize === 'mobile',
    isTablet: deviceSize === 'tablet',
    isDesktop: deviceSize === 'desktop'
  }
}
